import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { MDMService } from './mdmService.service';
import { Injectable } from '@angular/core';
import { Configuration } from '../../../shared';
import { BiUrls } from '../../biUrls';

@Injectable()
export class RoleAuthService {
    public updateURL : string; 


    constructor(public mdmService : MDMService,
        public toastr: ToasterComponent,
        public _global: Configuration
        ){
        this.updateURL = this._global.get('EPMS_BASE_URL') + 'v1/' + BiUrls.BIADMIN + '/' + BiUrls.PAGE
    }

    getRoleList(page, size){
        let self = this;
        let url = self.updateURL + BiUrls.GET_ROLES + '/'+ page + '/' + size;
        return new Promise<any>((resolve) => {
            self.mdmService.getRoleData(url).then(
                (res) => {
                    if (res == undefined) {
                        self.toastr.showError('Cannot load the Role Data');
                    } else {
                        let result = res.content != undefined ?
                            res.content.length == 0 ?
                                self.toastr.showWarning('No Roles to load') :
                                res :
                        self.toastr.showError('No Roles found');
                        resolve(result);
                    }
                }, (err) => {
                console.error(err);
            });
        });
    }

    getWidgetCount(roleIdList){
        let self = this;
        return new Promise((resolve) =>{
            let url = self.updateURL + BiUrls.GET_PAGE_AUTH_BY_ROLE + BiUrls.GET_ALL_WIDGET;
            self.mdmService.getRoleWidgets(url,roleIdList).then(
                (res) => {
                    if (res == undefined) {
                        self.toastr.showError('Cannot load the Count Data');
                    } else {
                    resolve(res.data);
                    }
                }, (err) => {
                    console.error(err);
            });
        });
    }

    getPages(){
        return new Promise((resolve) => {
            this.mdmService.onStartUp('../'+BiUrls.BIADMIN +'/'+ BiUrls.DASHBOARD_PAGES).then((res) => {
                if (res != undefined) {
                    let page = res.data != null ? res.data : [];
                    resolve(page);           
                }else{
                    resolve('completed');
                }
            }, (err) => {
                console.error(err);
            });
        });
    }

    getRoleAuth(roleId){
        let self = this;
        return new Promise<any>((resolve, reject) => {
        let url = self.updateURL + BiUrls.GET_PAGE_AUTH_BY_ROLE + BiUrls.GET_ALL
        self.mdmService.loadRoleAuthorizations(url, roleId).then((res) => {
            if (res != undefined) {
                let result = res.data != null ? res.data : [];
                resolve(result);
            }else{
                resolve(null);
            }
        }, (err) => {
            console.error(err);
            });
        });
    }

    editOrSave(path, psIdList, roleId){
        let self = this;
        let url = self.updateURL + BiUrls.GET_PAGE_AUTH_BY_ROLE + path + '/' + roleId;
        return new Promise<any>((resolve, reject) => {
            self.mdmService.onUpdateRoleAuth(url,psIdList).then((res) => {
                if(res){
                    resolve(res);
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/services/roleAuthService.service.ts